import { render } from "./transferencia-coletor.vue?vue&type=template&id=1736e3cc&scoped=true"
import script from "./transferencia-coletor.vue?vue&type=script&lang=js"
export * from "./transferencia-coletor.vue?vue&type=script&lang=js"

import "./transferencia-coletor.vue?vue&type=style&index=0&id=1736e3cc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1736e3cc"]])

export default __exports__